import React, { useState } from 'react';
import Button from "@material-ui/core/Button";
import { Link, Redirect, useHistory } from "react-router-dom";
import { auth } from "./firebase";
import "./Home.css";

function Home() {
    const [authenticated, isAuthenticated] = useState(false);
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const login = event => {
        event.preventDefault();
        auth.signInWithEmailAndPassword(email, password)
            .then((auth) => {
                history.push("/notes");
                isAuthenticated(true);
            })
            .catch(e => alert(e.message));
    }
    return (
        <div className="home">
            <form className="home__form">
                <Link className="home__link" to="/"><h1 className="home__logo">Wright</h1></Link>
                <input value={email} onChange={event => setEmail(event.target.value)} type="text" placeholder="Email ID" required />
                <input value={password} onChange={event => setPassword(event.target.value)} type="password" placeholder="Password" required /><br />
                <Button onClick={login} className="home__button" >Login</Button><br />
                <small>Dont have an account yet? <Link style={{ color: "blue", }} to="/create">Create one</Link></small><br /><br />
                <small style={{ textAlign: 'center', color: "gray", }}>Created by Japroz Singh Saini</small><br />
                <small style={{ textAlign: 'center', color: "gray", paddingBottom: "10px", }}>2020</small>
            </form>
        </div>
    )
}

export default Home
